import { Component, DOCUMENT, inject } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css'],
})
export class LoaderComponent {
  private readonly document = inject<Document>(DOCUMENT);

  public setLoader: boolean = false;

  showLoader() {
    this.setLoader = true;
    this.document.body.classList.add('no-scroll');
  }
  hideLoader() {
    this.setLoader = false;
    this.document.body.classList.remove('no-scroll');
  }
}
